<template>
<div style="height: 85vh;margin-top: 10px;padding: 0 10px; box-sizing: border-box;">
  <el-row :gutter="24" style="margin-right: 0;">
        <el-col :span="8">
          <el-form :inline="true" size="small" :model="query">
            <el-form-item label="会计月份">
              <el-date-picker format="yyyy-MM" value-format="yyyy-MM" v-model="query.accountingDate" type="month" placeholder="选择月"></el-date-picker>
            </el-form-item>
            <el-form-item label="抵扣状态">
              <el-select v-model="query.deductionStatus" placeholder="抵扣状态" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="已确认抵扣 " value="1"></el-option>
                <el-option label="未确认抵扣" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="2">
          <el-button size="small" type="primary" @click="getInvoicePage()"><i class="el-icon-search"></i> 查询</el-button>
        </el-col>
        <el-col :span="14" style="text-align: right">
          <el-button size="small" type="primary" @click="invoiceExport(false)">发票归档下载</el-button>
          <el-button size="small" type="primary" @click="invoiceExport(true)">导出抵扣文件</el-button>
        </el-col>
      </el-row>
  <el-row :gutter="24" style="margin-right: 0;">
  <el-col :span="4">
    <div class="grid-content bg-purple">
      <el-tree :data="tagList" :default-expanded-keys="['invoice']" node-key="value" :props="defaultProps" accordion @node-click="handleNodeClick"></el-tree>
    </div>
  </el-col>
  <el-col :span="20">
    <div class="grid-content">
     <div v-if="tableData.length>0">
      <el-table :data="tableData" :cell-class-name="setClass" @selection-change="handleSelectionChange" @cell-click="cellClick" :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#606266',height:'54px'}" border style="width: 100%" height="650px" stripe>
        <el-table-column prop="kprq" label="开票日期" width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="jshj" align="right" label="金额" width="100" show-overflow-tooltip>
          <template slot-scope="scope"> {{ formatRMBAmountExec(scope.row.jshj)}}</template>
        </el-table-column>
        <el-table-column prop="xfmc" label="销售方纳税人名称" width="360" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="xfsbh" label="销售方纳税人识别号" width="200" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="fpdm" label="发票代码" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="fphm" label="发票号码" width="180" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="remarks" label="凭证字号" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="se" align="right" label="票面税额" width="100" show-overflow-tooltip>
          <template slot-scope="scope"> {{ formatRMBAmountExec(scope.row.se)}}</template>
        </el-table-column>
        <el-table-column prop="se" align="right" label="有效抵扣税额" width="120" show-overflow-tooltip>
          <template slot-scope="scope"> {{ formatRMBAmountExec(scope.row.validDeductTax)}}</template>
        </el-table-column>
        <!-- <el-table-column prop="typeDescription" label="票种" width="160" show-overflow-tooltip></el-table-column> -->
        <!-- <el-table-column prop="deductionStatus" label="是否抵扣" width="80" show-overflow-tooltip>
          <template slot-scope="scope"> {{ scope.row.deductionStatus == '1' ? '是' : '否' }}</template>
        </el-table-column> -->
        <el-table-column prop="remarks" label="操作">
          <template slot-scope="scope">
            <el-button @click="deductionDo(scope.row)" v-if="scope.row.validDeductTax==0 || scope.row.validDeductTax=='' || scope.row.validDeductTax==null || scope.row.validDeductTax==undefined" size="mini" type="text">确认抵扣</el-button>
            <el-button @click="deductionCancel(scope.row)" v-if="!!scope.row.validDeductTax" size="mini" type="text">取消抵扣</el-button>
          </template>
        </el-table-column>
      </el-table>
     </div>
     <el-empty v-else :image-size="200"></el-empty>
      <el-pagination style="float: right;margin-top: 10px;" :page-sizes="tablePage.pageSizeList" layout="sizes,prev,pager,next" @current-change="changePage" @size-change="changeSize" :total="tablePage.tableCount"></el-pagination>
    </div>
  </el-col>
</el-row>

  <!-- 修改分类 -->
  <el-dialog title="编辑类别" :visible.sync="typeDialog.visible" width="20%" destroy-on-close>
      <el-select v-model="typeDialog.selectVal" placeholder="请选择类别" style="width: 100%;">
        <el-option v-for="item in typeDialog.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="typeDialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="submitTypeDialog">确 定</el-button>
      </span>
  </el-dialog>

  <!-- 认领发票 -->
  <el-dialog title="认领发票" wi :visible.sync="claim.visible" width="380px" destroy-on-close>
      <el-form label-position="top" :inline="true" label-width="80px">
        <el-form-item label="发票号码">
          <el-input v-model="claim.invoiceCode" style="width:340px" placeholder="请输入发票号码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="claim.visible = false">关闭</el-button>
        <el-button type="primary" @click="invoiceClaimExecSave">确 定</el-button>
      </span>
  </el-dialog>

  <!-- 上传发票 -->
  <upload-invoice-dialog :dialogVisible="showUploadInvoiceDialog" @close="closeUploadInvoiceDialog"></upload-invoice-dialog>

  <!-- 查看 -->
  <el-dialog title="查看发票" :visible.sync="showImagesVisible" width="800" destroy-on-close>
     <el-empty v-if="showImagesSrc == null || showImagesSrc == ''" description="无数据"></el-empty>
     <el-image style="height: 560px;width: 100%;" :src="showImagesSrc" fit="scale-down"></el-image>
  </el-dialog>

</div>
</template>

<script>
import { getInfo } from "@/cookie";
import { formatRMB } from "@/utils/kits";
import { mimeInvoiceList,updateType,deleteMimeInvoice,listInvoiceType,deductionPage,deductionDo,deductionExport,deductionCancel } from "@/api/invoice";
import { findInvoiceTypes,findNormalTags } from "@/api/dict";
import { Message, MessageBox } from 'element-ui';
import { invoiceClaim } from "@/api/process";

import UploadInvoiceDialog from './dialog/UploadInvoiceDialog.vue';


export default {
  name: "Personal",
  components : { UploadInvoiceDialog },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      multipleSelection:[],
      src_img : require('@/assets/avatar.png'),
      tagList:[],
      query: {
        type:[],
        invoiceIds: [],
        fphm: "",
        xfmc: "",
        time:'',
        accountingDate:'',
        jshj:'',
        reimburseStatus:'',
        deductionStatus:'',
        tagList: []
      },
      userInfo : {
        email : '-',
        openId: '',
        phone:'',
        unitName:'',
        unitTaxCode:'',
        userName:''
      },
      tableData: [],
      tablePage : {
        pageNum: 1,
        pageSize: 10,
        tableCount: 50,
        pageSizeList: [10,20]
      },
      typeDialog : {
          visible : false,
          selectVal:'',
          options : [],
          id:'',
      },
      claim : {
        visible:false,
        phoneNumber:'',
        invoiceCode:'',
      },

      showUploadInvoiceDialog: false,
      showImagesVisible : false,
      showImagesSrc : null,

    };
  },
  created() {
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1; // 月份是从 0 开始计数的，需要加1
    var formattedTime = year + "-" + (month < 10 ? "0" : "") + month
    this.query.accountingDate=formattedTime
    let info_ = getInfo();
    this.userInfo = {...info_};
    this.getInvoicePage();
    findInvoiceTypes().then(res => {
        this.typeDialog.options = res.data;
    });
    findNormalTags().then(res => {
        this.query.tagList = res.data;
    });
  },
  mounted(){
    listInvoiceType().then((res)=>{
      if(res.code==200){
        this.tagList=[
          {
            label:'全部',
            value:'invoice',
            children:res.data
          }
        ]
      }
    })
  },
  methods: {
    handleNodeClick(val){
      if(val.value=='invoice'){
        this.query.type=[]
      }else{
        this.query.type=[val.value]
      }
      this.getInvoicePage()
    },
    setClass({ row, column, rowIndex, columnIndex }) {
      if(column.property=='fphm'){
        return 'addBorder'
      }
    },
    //查看附件
    showImageClick(row){
        let url = window.location.origin;
        let src = row.fileId ? (url + '/api/common/image/preview?fileId=' + row.fileId) : (row.valueCode ? (url + '/api/common/image/preview?checksum=' + row.valueCode) : null);
        this.showImagesVisible = true;
        this.showImagesSrc = src;
    },
    cellClick(row, column, cell, event){
      if(column.property=='fphm'){
        this.showImageClick(row)
      }
    },
    //格式化金额
    formatRMBAmountExec(amount){
        return formatRMB(amount);
    },
    async invoiceExport(flag){
      let params={}
      params=Object.assign({},this.query,{onlyExcel:flag})
      const res = await deductionExport(params)
      if(res.type!=='application/json'){
        const a = document.createElement('a')
        const blobUrl = window.URL.createObjectURL(res)
        a.setAttribute('href', blobUrl)
        if(flag){
          a.setAttribute('download', '发票抵扣列表.xlsx')
        }else{
          a.setAttribute('download', '发票台账列表.zip')
        }
        a.click()
      }else{
        this.$message.error('导出失败！');
      }
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    deductionCancel(row){
      this.$confirm('确认是否取消抵扣？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
         type: 'warning'
      }).then(() => {
        let invoiceIds=[row.id]
        deductionCancel({invoiceIds}).then((res)=>{
          if(res.code==200){
            this.getInvoicePage();
            this.$message({
              message: res.msg,
              type: 'success'
            });
          }else{
            this.$message.error(res.msg);
          }
        })
      })
    },
    deductionDo(row){
      this.$prompt('请输入有效抵扣税额', '提示', {
        inputValue:row.se,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder:'请输入有效抵扣税额'
      }).then((res) => {
        let invoiceIds=[row.id]
        deductionDo({invoiceIds,validDeductTax:res.value}).then((res)=>{
          if(res.code==200){
            this.getInvoicePage();
            this.$message({
              message: res.msg,
              type: 'success'
            });
          }else{
            this.$message.error(res.msg);
          }
        })
      })
    },
   
    //关闭上传弹框
    closeUploadInvoiceDialog(){
       this.showUploadInvoiceDialog = false;
       this.getInvoicePage();
    },

    //打开上传弹框
    openUploadInvoiceDialog(){
       this.showUploadInvoiceDialog = true;
    },

    //编辑分类
    updateTypeDialog(row){
       this.typeDialog.id = row.id;
       this.typeDialog.visible = true;
       this.typeDialog.selectVal = row.type == '-' ? '' : row.type;
    },

    //提交编辑
    submitTypeDialog(){
       let id  = this.typeDialog.id;
       let val = this.typeDialog.selectVal;
       let this_ = this;
       updateType({id:id,type:val}).then(res => {
          this_.getInvoicePage();
          this_.typeDialog.visible = false;
       });
    },

    //获取数据
    getInvoicePage(){
        let param = Object.assign({},this.query);
            param.kprqStart=param.time[0] || ''
            param.kprqEnd=param.time[1] || ''
            param.pageNum  = this.tablePage.pageNum;
            param.pageSize = this.tablePage.pageSize;
            delete param.time
            deductionPage(param).then(res => {
              if(res.code==200){
                this.tableData = res.data.content || [];
                this.tablePage.tableCount = res.data.totalElements;
              }
            });
    },

    //格式化金额
    formatRMBExec(row){
      let je = row.vatInvoiceTotalCoverTaxDigits;
      if(je == null || je == ''){
         je = row.jshj;
      }
      return formatRMB( je);
    },
    //切换分页
    changePage(val1){
        this.tablePage.pageNum = val1;
        this.getInvoicePage();
    },
    //切换分页
    changeSize(val) {
        this.tablePage.pageSize = val;
        this.getInvoicePage();
    },
    //设置默认值
    defaultText(val){
      return val == null || val == '' ? '-' : val;
    },

    //删除发票
    deleteMineInvoice(row){
      let this_ = this;
      MessageBox.confirm('确定要删除该发票吗?删除后将不可恢复.', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            deleteMimeInvoice(row.id).then(res => {
                if( res.code == 200){
                    Message.success('处理成功');
                    this_.getInvoicePage();
                } else {
                    Message.error(res.msg);
                } 
            });
        }).catch(() => {
                  
      });
    },

    //认领发票
    invoiceClaimExec(){
      this.claim.invoiceCode = null;
      this.claim.visible = true;
    },
    invoiceClaimExecSave(){
      let fphm = this.claim.invoiceCode;
      if(fphm == null || fphm == ''){
         Message.warning('发票号码不能为空');
         return; 
      }
      let info = getInfo();
      let param = {invoiceCode:fphm,phoneNumber:info.phone}
      let this_ = this;
      invoiceClaim(param).then(res => {
          if( res.code == 200){
              if( res.data == null){
                  Message.warning('认领失败,发票不存在.');
              } else {
                  Message.success('发票【' + fphm + '】认领成功.');
                  this_.getInvoicePage();
              }
          } else {
              Message.error(res.msg);
          }
      })
    },
    
    //查看附件
    showImageClick(row){
        let url = window.location.origin;
        let src = row.fileId ? (url + '/api/common/image/preview?fileId=' + row.fileId) : (row.valueCode ? (url + '/api/common/image/preview?checksum=' + row.valueCode) : null);
        this.showImagesVisible = true;
        this.showImagesSrc = src;
    }

  },
};
</script>


<style scoped>
.avatar-div {
    width: 100%;
    height: 80px;
    text-align: center;
    padding-top: 30px;
    span {
    
      width: 70px;
      height: 70px;
      line-height: 70px;

    }
}
.el-row {
    margin-bottom: 0px;
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
   border: 1px solid #f3f3f3;
   padding: 10px;
   box-sizing: border-box;
  }
  .bg-purple-light {
    /* background: #e5e9f2; */
  }
  .grid-content {
    /* padding: 20px; */
    /* box-sizing: border-box; */
    border-radius: 4px;
    min-height: 715px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }


</style>
<style>
  .addBorder div{
    color: #409eff !important;
    /* text-decoration: underline; */
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/views/components/Personal.vue